import { useMutation } from '@apollo/client'
import { ImportQuestionnaireV2MutationVariables } from '../../data/gql-gen/questionnaire/graphql'
import { ImportQuestionnaireV2Mutation } from '../../data/gql-gen/questionnaire/graphql'
import { IMPORT_QUESTIONNAIRE_V2 } from '../../data/gql/questionnaire/mutations/importQuestionnaireV2'
import { draftQuestionnaireRefetchQuery } from '../../data/gql/questionnaire/queries'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const useImportQuestionnaireV2 = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()

  const [importQuestionnaireV2] = useMutation<
    ImportQuestionnaireV2Mutation,
    ImportQuestionnaireV2MutationVariables
  >(IMPORT_QUESTIONNAIRE_V2, {
    context: { clientName: 'questionnaire' },
    refetchQueries: [
      draftQuestionnaireRefetchQuery(projectId, surveyId, waveId)
    ],
    onError: (error) => {
      captureApolloError(
        LoggerErrorType.ApolloQuery,
        'importQuestionnaireV2',
        error
      )
    }
  })

  return { importQuestionnaireV2 }
}
